import { MutableRefObject, Ref, useCallback, useRef } from "react"

export function useExternalRef<T>(externalRef?: Ref<T>): MutableRefObject<T | null> {
    const internalRef = useRef<T | null>(null)

    const setRef = useCallback(
        (instance: T | null) => {
            if (typeof externalRef === "function") {
                externalRef(instance)
            } else if (externalRef && "current" in externalRef) {
                ;(externalRef as MutableRefObject<T | null>).current = instance
            }
            internalRef.current = instance
        },
        [externalRef]
    )

    return {
        get current() {
            return internalRef.current
        },
        set current(instance: T | null) {
            setRef(instance)
        },
    } as MutableRefObject<T | null>
}
